import { ValidateDiscountCodeState } from './validateDiscountCode.types'

export const validateDiscountCodeInitialState: ValidateDiscountCodeState = {
  loading: false,
  error: null,
  success: null,
  validationStatus: 'idle',
  lastValidatedCode: null
}
